<template>
  <AuthFormWrapper>
    <template v-if="passwordReset">
      <p class="text-center">
        Your password has been reset.
      </p>

      Click <RouterLink :to="{ name: 'app_auth_login' }">
        here
      </RouterLink> to log in.
    </template>

    <template v-else>
      <p>Reset your password below</p>

      <ResetPasswordForm @password-reset="passwordReset = true" />
    </template>
  </AuthFormWrapper>
</template>

<script setup>
import { ref } from 'vue';
import { useRoute } from 'vue-router';

import { ResetPasswordForm } from '@/components/forms/index.js';
import { AuthFormWrapper } from '@/components/wrappers/index.js';

const token = useRoute().query.token;
const error = ref(null);
const passwordReset = ref(false); // TODO: rename this variable to something better

if (!token) {
  error.value = 'This password reset link is either invalid or has expired.';
}
</script>
